import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs/index';


@Injectable()
export class AppLoadingService {
  private _isLoadingBS: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isLoading$: Observable<boolean> = this._isLoadingBS.asObservable();

  setLoading() {
    this._isLoadingBS.next(true);
  }

  clearLoading() {
    this._isLoadingBS.next(false);
  }
}
